import {
  Configuration,
  CreateProperty,
  CreatePropertyForOrg201Response,
  GetPropertiesByOrgId200Response,
  OpeningHour,
  PropertiesApi,
  UpdateProperty,
} from '@flipdish/orgmanagement';

import { getApiEndPoint } from '../../helpers/apibase';
import { mapServerError } from '../../services/utils/serverErrorMapper';

const baseURL = getApiEndPoint();

const configuration = new Configuration({
  basePath: baseURL,
  useDefaultUserAgent: true,
});

const defaultOptions = {
  withCredentials: true,
};

const propertiesApi = new PropertiesApi(configuration);

export const getAllPropertiesForOrgKey = 'getAllPropertiesForOrg';
export async function getAllPropertiesForOrg(
  orgId: string
): Promise<{ data: GetPropertiesByOrgId200Response }> {
  try {
    return await propertiesApi.getPropertiesByOrgId(orgId, defaultOptions);
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
}
// #endregion

// #region getPropertyOpeningHours
export const getPropertyOpeningHoursKey = 'getPropertyOpeningHours';
export async function getPropertyOpeningHours(orgId: string, propertyId: string) {
  try {
    return await propertiesApi.getOpeningHoursByPropertyId(orgId, propertyId, defaultOptions);
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
}
// #endregion

// #region updatePropertyOpeningHours
export const updatePropertyOpeningHoursKey = 'updatePropertyOpeningHours';
export async function updatePropertyOpeningHours(
  orgId: string,
  propertyId: string,
  openingHour: OpeningHour[]
) {
  try {
    return await propertiesApi.updateOpeningHoursForProperty(
      orgId,
      propertyId,
      openingHour,
      defaultOptions
    );
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
}

export const createPropertyForOrgKey = 'createPropertyForOrg';
export async function createPropertyForOrg(
  orgId: string,
  property: CreateProperty
): Promise<{ data: CreatePropertyForOrg201Response }> {
  try {
    return await propertiesApi.createPropertyForOrg(orgId, property, defaultOptions);
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
}

export const getPropertyByIdKey = 'getPropertyById';
export async function getPropertyById(orgId: string, propertyId: string) {
  try {
    return await propertiesApi.getPropertyById(orgId, propertyId, defaultOptions);
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
}

export const updatePropertyByIdKey = 'updatePropertyById';
export async function updatePropertyById(
  orgId: string,
  propertyId: string,
  property: UpdateProperty
): Promise<{ data: any }> {
  try {
    return await propertiesApi.updatePropertyById(orgId, propertyId, property, defaultOptions);
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
}

export const archivePropertyKey = 'archiveProperty';
export const archiveProperty = async (orgId: string, propertyId: string) => {
  try {
    await propertiesApi.archiveProperty(orgId, propertyId, defaultOptions);
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
};

export const unarchivePropertyKey = 'unarchiveProperty';
export const unarchiveProperty = async (orgId: string, propertyId: string) => {
  try {
    await propertiesApi.unarchiveProperty(orgId, propertyId, defaultOptions);
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
};

const propertiesService = {
  getAllPropertiesForOrg,
  createPropertyForOrg,
  updatePropertyById,
  getPropertyById,
  archiveProperty,
  unarchiveProperty,
  getPropertyOpeningHours,
  updatePropertyOpeningHours,
};

export default propertiesService;
